/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
import http from '@/utils/http/axios';
import type {
  NoPayOrderPageList,
  PayedOrderPageList,
  ConfirmPageList,
  OrderDetail,
  OrderFeeViewDetail,
  ProhibitList
} from './types';
import router from '@/router';

enum Api {
  noPayOrderPageList = '/front-end/order-manager/asp/paymentCenter/orderManagement/noPayOrderPageList', // 未完结订单列表
  payedOrderPageList = '/front-end/order-manager/asp/paymentCenter/orderManagement/payedOrderPageList', // 已完结订单列表
  noPayOrderCheckStatistics = '/front-end/order-manager/asp/paymentCenter/orderManagement/noPayOrderCheckStatistics', // 未完结订单勾选统计
  confirmPageList = '/front-end/order-manager/asp/paymentCenter/orderManagement/noPayOrder/confirmPageList', // 未完结订单支付信息确认列表
  statisticsConfirmList = '/front-end/order-manager/asp/paymentCenter/orderManagement/noPayOrder/statisticsConfirmList', // 未完结订单支付信息汇总确认（按项目汇总）
  prohibitList = '/front-end/order-manager/asp/paymentCenter/orderManagement/prohibitList', // 个体-支付订单-禁止拦截列表（内存分页）

  orderExport = '/front-end/asp-order-export/orderExport', // 支付中心-订单导出

  personViewDetail = '/front-end/order-manager/asp/paymentCenter/orderManagement/person/viewDetail', // 查看明细(项目费用)-自然人(分页)
  removePerson = '/front-end/order-manager/asp/paymentCenter/orderManagement/remove', // 移除人员
  individualViewDetail = '/front-end/order-manager/asp/paymentCenter/orderManagement/individual/viewDetail', // 查看明细(项目费用)-个体(分页)
  supplierPeopleViewDetail = '/front-end/order-manager/asp/paymentCenter/orderManagement/supplier/people/viewDetail', // 查看明细(项目费用)-供应商-个人(分页)
  supplierViewDetail = '/front-end/order-manager/asp/paymentCenter/orderManagement/supplier/viewDetail', // 查看明细(项目费用)-供应商
  orderFeeViewDetail = '/front-end/order-manager/asp/paymentCenter/orderManagement/order/fee/viewDetail', // 查看明细-平台服务费/商务服务费

  getVerifyCodeApi = '/front-end/order-manager/asp/paymentCenter/orderManagement/sendSms', // 获取手机号验证码（发短信）
  paySubmit = '/front-end/order-manager/asp/paymentCenter/orderManagement/submit', // 发起支付 提交
  operatorInfo = '/front-end/order-manager/asp/paymentCenter/orderManagement/operatorInfo', // 发短信-查询经办人电话

  prohibitVerification = '/front-end/order-manager/asp/paymentCenter/orderManagement/prohibitVerification', // 个体-支付订单-禁止拦截校验逻辑
  orderPayment = '/front-end/limit/order/payment' // 支付订单计算超限人员
}

const getTaxType = () => {
  // 获取订单来自劳务还是经营taxType
  return { taxType: router.currentRoute.value.meta.taxType };
};
export const paySubmit = async (params: {
  verifyCode?: string;
  aspOrderIdList: number[];
}) =>
  http.request({
    url: Api.paySubmit,
    method: 'POST',
    params: {
      ...getTaxType(),
      ...params
    }
  });
export const supplierViewDetail = async (params: {
  aspOrderId: number;
  projectStructureType: number;
}): Promise<
  Result<
    {
      id: number; //
      supplierName: string; //供应商名称
      finishSum: number; //结算任务量（条）
      terminalSettlementPrice: number; //终端结算单价（分）
      terminalSettlementAmount: number; //终端结算金额（分）
      supplierServiceRate: string; //供应商服务费率（%）
      orderPaymentAmount: number; //订单支付金额（分）
      payStatus: number; //支付状态  0 未支付 1 支付中  2支付成功 3 支付失败
    }[]
  >
> => {
  return http.request({
    url: Api.supplierViewDetail,
    method: 'POST',
    params: {
      ...getTaxType(),
      ...params
    }
  });
};

export const orderFeeViewDetail: OrderFeeViewDetail = params =>
  http.request({
    url: Api.orderFeeViewDetail,
    method: 'POST',
    params: {
      ...getTaxType(),
      ...params
    }
  });
export const orderDetail: OrderDetail = params => {
  const apiMap = {
    3: Api.personViewDetail,
    2: Api.individualViewDetail,
    1: Api.supplierPeopleViewDetail
  };
  return http.request({
    url: apiMap[+params.projectStructureType],
    method: 'POST',
    params: {
      ...getTaxType(),
      ...params
    }
  });
};
export const confirmPageList: ConfirmPageList = params =>
  http.request({
    url: Api.confirmPageList,
    method: 'POST',
    params: {
      ...getTaxType(),
      ...params
    }
  });

export const noPayOrderPageList: NoPayOrderPageList = params => {
  return http.request({
    url: Api.noPayOrderPageList,
    method: 'POST',
    params: {
      ...getTaxType(),
      ...params
    }
  });
};

export const payedOrderPageList: PayedOrderPageList = params =>
  http.request({
    url: Api.payedOrderPageList,
    method: 'POST',
    params: {
      ...getTaxType(),
      ...params
    }
  });

export const removePerson = async (params: {
  ids: number[];
  projectStructureType: number;
  aspOrderId: number;
}) =>
  http.request({
    url: Api.removePerson,
    method: 'POST',
    params: {
      ...getTaxType(),
      ...params
    }
  });
export const statisticsConfirmList = async (params: {
  aspOrderIdList: number[];
}): Promise<
  Result<
    {
      projectName: string; //项目名称
      payOrderNum: number; //支付订单数量
      orderPaymentTotalAmount: number; //订单支付总金额(分)
      payPassagewayCode: number; //支付通道(英文)  zbBank-众邦银行  fyBank-富友支付 offLineBank-网银支付
      payPassagewayName: number; //支付通道(中文)  zbBank-众邦银行  fyBank-富友支付 offLineBank-网银支付
      statisticsConfirmDetailList: {
        orderId: number; //订单ID
        aspOrderId: number; //Asp订单ID
        orderType: number; //订单类型 1-项目服务费 2-平台服务费 3-商务服务费
        orderNo: number; //订单编号
        orderPaymentAmount: number; //订单支付金额
        paymentRecipientDescribe: number; //支付对象描述
      }[];
    }[]
  >
> =>
  http.request({
    url: Api.statisticsConfirmList,
    method: 'POST',
    params: {
      ...getTaxType(),
      ...params
    }
  });

export const noPayOrderCheckStatistics = async (params: {
  aspOrderIdList: number[];
}): Promise<
  Result<{
    orderNum: number; //已选订单数量（项目服务费+平台服务费+商务服务费）
    orderAmount: number; //订单总金额（项目服务费+平台服务费+商务服务费）
    platformServiceFeeAmount: number; //平台服务费订单总金额
    businessServiceFeeAmount: number; //商务服务费订单总金额
    techServiceFeeTotalAmount: number; //技术服务费订单总金额
  }>
> =>
  http.request({
    url: Api.noPayOrderCheckStatistics,
    method: 'POST',
    params: {
      ...getTaxType(),
      ...params
    }
  });

export const getVerifyCodeApi = async params =>
  http.request({
    url: Api.getVerifyCodeApi,
    method: 'POST',
    params: {
      ...getTaxType(),
      ...params
    }
  });

export const operatorInfo = async (params: {
  t: number;
}): Promise<
  Result<{
    phone: string;
  }>
> =>
  http.request({
    url: Api.operatorInfo,
    method: 'POST',
    params: {
      ...getTaxType(),
      ...params
    }
  });

export const prohibitList: ProhibitList = async params =>
  http.request({
    url: Api.prohibitList,
    method: 'POST',
    params: {
      ...getTaxType(),
      ...params
    }
  });

export const orderExport = (params: {
  exportType: number;
  reqParam: {
    prohibitInterceptCacheKey: string;
  };
}) =>
  http.download({
    url: Api.orderExport,
    method: 'POST',
    params
  });

export const prohibitVerification = async (params: {
  aspOrderIdList: number[];
}) =>
  http.request({
    url: Api.prohibitVerification,
    method: 'POST',
    params: {
      ...getTaxType(),
      ...params
    }
  });

export const orderPayment = async (params: { aspOrderIdList: number[] }) =>
  http.request({
    url: Api.orderPayment,
    method: 'POST',
    params: {
      ...getTaxType(),
      ...params
    }
  });
